export const ORDER_API_NAMES = {
  OpenOrdersLeanGet2: `OpenOrdersLeanGet2`,
  OrderHistoryGet3: `OrderHistoryGet3`
};
